module.exports = __webpack_public_path__ + "img/icon-callendar.44974ffb.svg";